import type {
    FirestoreDataConverter,
    QueryDocumentSnapshot,
    SnapshotOptions,
} from 'firebase/firestore'
import type { SimulatorLayout, SimulatorLayoutDocument } from '~/types/simulator/simulator'

export const simulatorLayoutConverter: FirestoreDataConverter<SimulatorLayout> = {
    fromFirestore: (
        snapshot: QueryDocumentSnapshot<SimulatorLayout>,
        options: SnapshotOptions,
    ): SimulatorLayout => {
        const data = snapshot.data(options)

        return { ...data, id: snapshot.id } as SimulatorLayout // Adjust this mapping as necessary
    },
    toFirestore: (modelObject: SimulatorLayout): SimulatorLayoutDocument => {
        const { id, ...simulatorLayoutDoc } = modelObject
        return { ...simulatorLayoutDoc }
    },
}
